import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './ServicePackagesEditor.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";


interface EvServiceEntry {
    serviceID: string;
    serviceColor: more.EntityAPIColor;
    assignmentID: string;
    description: string;
    isDeleted?: boolean;
    blobNode?: HTMLElement;
    blobIcon?: HTMLElement;
}
class ServicePackagesEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    sp_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    sp_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    //sp_Input_ServicePackGroup: SearchSelect = new SearchSelect();
    sp_input_Services: MdsLax<InstanceType<typeof MultiselectBox>>;

    inputServicesContainer: HTMLElement;
    selectedServicesContainer: HTMLElement;

    selectedServices: Array<EvServiceEntry> = [];

    formData: MainCatalogTypes.ServicePackage_SaveData = {
        ID: "",
        is_new_status: null,
        description: "",
        note: "",
        //service_pack_group_id: "",
        evServices: []
    };

    prepareFormData(data?: MainCatalogTypes.ServicePackage_LoadData): void {

        let servicePackGroupId: string = null;
        this.selectedServices = [];
        let alreadySelectedServices: Array<string>;

        if (data) {
            this.selectedServices = data.evServices;

            this.sp_Input_Description.setValue(data.description, true);
            this.sp_Input_Note.setValue(data.note, true);

            //this.sp_Input_ServicePackGroup._loadListValues(data.ref_service_pack_group?.ID, true);
            //servicePackGroupId = data.ref_service_pack_group?.ID

            alreadySelectedServices = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
                return assignment.serviceID;
            });

            if (this.sp_input_Services.entries) this.sp_input_Services.setValue(alreadySelectedServices, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.sp_Input_Description.setValue("", true);
            this.sp_Input_Note.setValue("", true);

            //this.sp_Input_ServicePackGroup._loadListValues();

            alreadySelectedServices = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
                return assignment.serviceID;
            });
            if (this.sp_input_Services.entries) this.sp_input_Services.setValue(alreadySelectedServices, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData(/*servicePackGroupId*/);
        this.formData.evServices.forEach((x: EvServiceEntry) => { x.isDeleted = false; });
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();

        this._onChangeInput_Services(alreadySelectedServices/*, servicePackGroupId*/);
    }

    private addServiceBlob(serviceAssignment: EvServiceEntry) {

        let blob = this.UiModder.domConstruct.create("div", {
            className: "flex_row_center round nowrap border w3-tooltip",
            order: 100
        }, this.selectedServicesContainer);

        let tooltip = this.UiModder.domConstruct.create("span", {
            style: "position:absolute;left:22px;bottom:16px; pointer-events:none;",
            class: "w3-text w3-tag w3-pale-yellow w3-round w3-animate-opacity w3-border",
            innerHTML: serviceAssignment.description
        }, blob);

        let blobX = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base mds-hover-dark warningTXT round",
            innerHTML: "<i class='fas fa-times'></i>"
        }, blob);
        on(blobX, "click", lang.hitch(this, this._onClick_RemoveService, serviceAssignment));


        // gelöscht?
        this.UiModder.domClass.toggle(blob, "strike w3-disabled", serviceAssignment.isDeleted === true);

        let blobLabel = this.UiModder.domConstruct.create("div", {
            className: "paddingSmall",
            style: "max-width: 250px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;",
            innerHTML: serviceAssignment.description
        }, blob);

        let colorHexBG = "#ffffff";
        let colorHexTXT = "#000000";
        if (serviceAssignment.serviceColor) {
            colorHexBG = serviceAssignment.serviceColor.BackColor?.Hex;
            colorHexTXT = serviceAssignment.serviceColor.TextColor?.Hex;
        }

        if (colorHexBG) {
            this.UiModder.domStyle.set(blob, "backgroundColor", colorHexBG);
        }

        if (colorHexTXT) {
            this.UiModder.domStyle.set(blobLabel, "color", colorHexTXT);
        }
    }

    private drawSelectedCategoryBlobs(data?: MainCatalogTypes.ServicePackage_SaveData) {

        if (!data) {
            data = this.formData;
        }

        this.UiModder.domConstruct.empty(this.selectedServicesContainer);

        let servicesIds: Array<string> = [];

        if (data) {
            for (let assignedService of <Array<EvServiceEntry>>data.evServices) {
                // wir benötigen:
                // categoryIds (nicht assignment) für das Searchselect, damit die dort vorausgewählt sind
                // und wir erstellen die Blobs für schnellere Übersicht

                if (!assignedService.isDeleted) {
                    servicesIds.push(assignedService.serviceID);
                }

                this.addServiceBlob(assignedService);
            }
        }
    }

    private _onClick_RemoveService(targetAssignment: EvServiceEntry) {

        let selectedIDs: Array<string> = [];

        let deletedCategory = this.selectedServices.filter(x => x.serviceID === targetAssignment.serviceID)[0];

        deletedCategory.assignmentID ? deletedCategory.isDeleted = true : this.selectedServices.splice(this.selectedServices.indexOf(deletedCategory), 1);

        this.selectedServices.forEach(serviceAssignment => {

            if (serviceAssignment.isDeleted !== true) selectedIDs.push(serviceAssignment.serviceID);
        });

        this.sp_input_Services.setValue(selectedIDs);
    }

    serializeFormData(/*servicePackGroupId?: string*/): void {

        this.formData.description = this.sp_Input_Description.getValue();
        this.formData.note = this.sp_Input_Note.getValue();

        //servicePackGroupId ? this.formData.service_pack_group_id = servicePackGroupId : this.formData.service_pack_group_id = this.sp_Input_ServicePackGroup.getValue();

        this.formData.evServices = this.selectedServices;

        console.debug("SERIALIZED DATA", this.formData);
    }

    loadEvServicesMultiSelect(): void {

        let requestUrl = window.appRoot + "MainCatalogsEditor/GetEvServicesMultiSelectList";
        //this.StandbyStart();
        this.UiModder.domClass.add(this.inputServicesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");

        this.RequestManager.post(
            requestUrl,
            null,
            lang.hitch(this, this._onLoadEvServicesMultiSelectResult),
            lang.hitch(this, this._onLoadEvServicesMultiSelectError),
            false // sync
        );
    }

    _onLoadEvServicesMultiSelectResult(data: any): void {

        let preset: Array<string> = [];
        let alreadySelectedServices = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
            return assignment.serviceID;
        });
        if (alreadySelectedServices.length > 0) preset = alreadySelectedServices;
        else preset = this.sp_input_Services.getValue();

        this.sp_input_Services.setData(preset, data, true);

        this.UiModder.domClass.remove(this.inputServicesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");
    }

    _onChangeInput_Services(newValues: Array<string>, /*servicePackGroupId?: string*/) {

        let entityValues = this.sp_input_Services.getValue(true);
        let labelProp = this.sp_input_Services.labelAttribute;
        let valueProp = this.sp_input_Services.valueAttribute;
        console.log("_onChangeInput_Services", newValues, entityValues);

        let missingServices: Array<string> = [];
        let alreadySelectedServices: Array<string> = (<Array<EvServiceEntry>>this.selectedServices).map(function (assignment) {
            return assignment.serviceID;
        });

        let newAssignmentArray: Array<EvServiceEntry> = [];

        //for (let index = 0; index < this.selectedServices.length; index++) {
        //    let categoryAssignment: EvServiceEntry = this.selectedServices[index];

        //    if (categoryAssignment.assignmentID) {
        //        categoryAssignment.isDeleted = newValues.indexOf(categoryAssignment.serviceID, 0) == -1;

        //        newAssignmentArray.push(categoryAssignment);
        //    } else if (newValues.length > 0 && newValues.indexOf(categoryAssignment.serviceID) > -1) {

        //        newAssignmentArray.push(categoryAssignment);
        //    }
        //}

        this.selectedServices.forEach(serviceAssignment => {

            if (serviceAssignment.assignmentID) {

                serviceAssignment.isDeleted = newValues.indexOf(serviceAssignment.serviceID) == -1;
            }

            if ((newValues.length > 0 && newValues.indexOf(serviceAssignment.serviceID) > -1) || serviceAssignment.isDeleted !== undefined) {

                newAssignmentArray.push(serviceAssignment);
            }
        });

        for (let entity of entityValues) {
            if (alreadySelectedServices.indexOf(entity[valueProp]) == -1) { // bisher noch nicht zugeordnet - neuer Eintrag!
                newAssignmentArray.push({
                    assignmentID: null,
                    serviceID: entity[valueProp],
                    serviceColor: entity.coloration,
                    description: entity[labelProp],
                });
            }
        }

        //this.formData.categories = newAssignmentArray;
        this.selectedServices = newAssignmentArray;

        this.serializeFormData(/*servicePackGroupId*/);
        this.checkDirty();

        this.drawSelectedCategoryBlobs();
    }

    _onChangeServicePackageInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.sp_Input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    _onLoadEvServicesMultiSelectError(err: any): void {

        // TODO
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.description) b = false;

        return b;
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        on(this, "CatalogEntityData_Save", () => {
            this.sp_input_Services.setValue(null, true);
        });
        this.loadEvServicesMultiSelect();

        this.entityClass = MainCatalogs_Classes.ServicePackage;

        this.sp_Input_Description.setMaxLength(255);
        this.sp_Input_Note.setMaxLength(2000);
        this.sp_Input_Note.setValidationEnabled(false);

        //this.UiModder.domAttr.set(this.sp_Input_ServicePackGroup.outerInput, "placeholder", this.translations["MainCatalogsEditor_Placeholder_ServicePackGroup"]);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(ServicePackagesEditor.prototype, {
  sp_Input_Description: () => (new Edit()),
  sp_Input_Note: () => (new Edit()),
});
export default mdsWidget(ServicePackagesEditor);